import { useApiOrganisationPeriodJobsAssignmentDetailsList } from 'state/__generated__/tadaahAPI';
import type { PeriodJobAssignmentDetails } from 'state/__generated__/tadaahAPI';

type UseGetPeriodjobAssignmentDetailstHandler = {
  data: PeriodJobAssignmentDetails;
  error: string | null;
  isLoading: boolean;
  refetch: () => void;
};

const useGetPeriodJobAssignmentDetails = (
  id: number,
): UseGetPeriodjobAssignmentDetailstHandler => {
  const { data, error, isLoading, refetch } =
    useApiOrganisationPeriodJobsAssignmentDetailsList(id.toString());

  return {
    data: data?.data ?? ({} as PeriodJobAssignmentDetails),
    error: error?.message || null,
    isLoading,
    refetch,
  };
};

export default useGetPeriodJobAssignmentDetails;
